import { ISignUpModel, ISignUpResponseModel } from 'modules/account/features/singup/models';
import API from 'services/api';

export const signUp = (values: ISignUpModel): Promise<ISignUpResponseModel> =>
  API.post('/api/customers/signup', values).then(response => response?.data);

export const resendActivationMail = (email: string) =>
  API.post('/api/users/resend-signup-mail', null, { params: { email } })?.then(
    response => response?.data,
  );

export const resendActivationLiteMail = (email: string) =>
  API.post('/api/users/resend-activation-mail', null, { params: { email } })?.then(
    response => response?.data,
  );
